import { PublicationStatus } from '@prisma/client';

export type ProjectForManualInvoicing = { status: PublicationStatus };

export const isProjectValidForManualInvoicing = (project: ProjectForManualInvoicing): boolean =>
  project.status === PublicationStatus.LIVE;
